import { ClientResponseError } from 'pocketbase';
import i18n from '../i18n';

/**
 * The hooks send `data.reason = ValidationError(code, message)` (pb_hooks/lib/common.js),
 * so a translated message can be looked up under errors.<code>.
 */
export function errorCode(err: unknown): string | null {
  if (err instanceof ClientResponseError) {
    const reason = (err.response?.data as { reason?: { code?: string } } | undefined)?.reason;
    if (reason?.code) return reason.code;
    if (err.status === 409) return 'stale_revision';
    if (err.status === 0) return 'network';
    if (err.status === 401) return 'unauthorized';
    if (err.status === 429) return 'rate_limited';
  }
  return null;
}

export function errorMessage(err: unknown): string {
  const code = errorCode(err);
  // The server's own message, for translations that show it (e.g. which game-data field is invalid).
  const detail =
    err instanceof ClientResponseError
      ? ((err.response?.data as { reason?: { message?: string } } | undefined)?.reason?.message ?? '')
      : '';
  if (code && i18n.exists(`errors.${code}`)) return i18n.t(`errors.${code}`, { detail });
  if (err instanceof ClientResponseError) {
    const fieldErrors = Object.entries(err.response?.data ?? {})
      .filter(([k]) => k !== 'reason')
      .map(([k, v]) => `${k}: ${(v as { message?: string })?.message ?? ''}`);
    return [err.message, ...fieldErrors].filter(Boolean).join(' — ');
  }
  return err instanceof Error ? err.message : String(err);
}
